import styled from "styled-components";

export const FormButtonStyle = styled.div`
  .form-button {
    width: 20vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
  }

  .btn-div {
    display: flex;
    justify-content: center;
  }
`;
